import React from 'react'
import { Row, Col, Card } from 'antd'
import { CloseCircleFilled } from '@ant-design/icons'
import Banner from '../Banner/Banner'
import DynamicCard from '../Form/Form'
// import Footer from '../Footer/Footer'
import Btn from '../Button/Button'
import graphImg from '../assets/Currency-Accounts-Platform.png'
import BTCImg from '../assets/BTC.svg'
import CNYImg from '../assets/CNY.svg'
import EURImg from '../assets/EUR.svg'

import './SignUp.scss'

const SignUp = props => {
  const {
    bannerText,
    bannerTitle,
    label,
    logo,
    banner,
    userName,
    formTitle,
    formSubTitle,
    formData,
    signUp,
    enableLoginLink,
    stepStatus,
    companyStageOneStatus,
    companyStageTwoStatus,
    finalProgressStatus,
    registrationStatus,
    productSelectionStatus,
    preQualificationStatus,

    viewDescription,
    cardDescription,

    // copyRights,
    handleHomePage,
    backgroundHeight,
    loading,
    mainLoader,
    handleCloseDescription,

    viewForm,
    cardMessage,
    handleRedirectLogin,
    inProgressItem,
    progressLog,

    footerHeight,
    handleClickFun,
    isUserEnabled2FA,
    onChangeEnable2fa,
    // handlePrivacyPolicy,
    // handleTermsAndServices,
    isTermsConditionsAccpted,
    isUserNeedEmailUpdates,
    onChangeTermsConditions,
    onChangeEmailUpdates,
    initialFormValues,
    onFieldsChange,
    onSubmitForm,
  } = props

  return (
    <div style={{ background: '#f5f5ef' }}>
      <Banner
        bannerText={bannerText}
        bannerTitle={bannerTitle}
        userName={userName}
        logo={logo}
        banner={banner}
        handleHomePage={handleHomePage}
        handleRedirectLogin={handleRedirectLogin}
      />
      {viewDescription ? (
        <div className="main-body" style={{ marginTop: '50px', background: '#F5F5EF' }}>
          <Row>
            <Col span={18} offset={3}>
              <Card
                bordered={false}
                bodyStyle={{ padding: '50px' }}
                style={{
                  borderRadius: '19px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    textAlign: 'right',
                    marginTop: '-28px',
                    marginRight: '-25px',
                    marginBottom: '25px',
                  }}
                >
                  <CloseCircleFilled className="gl-circle-close" onClick={handleCloseDescription} />
                </div>
                <div>{cardDescription}</div>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <Btn
                    label="BACK"
                    shape="round"
                    size="large"
                    className="btn-submit"
                    style={{ width: '200px' }}
                    onClick={handleCloseDescription}
                  />
                </div>
              </Card>
            </Col>
          </Row>
          <div style={{ height: backgroundHeight, background: '#F5F5EF' }} />
          {/* <Footer
            copyRights={copyRights}
            handlePrivacyPolicy={handlePrivacyPolicy}
            handleTermsAndServices={handleTermsAndServices}
          /> */}
        </div>
      ) : (
        <div className="main-body">
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
              <div className="mainContent-left">
                <img src={graphImg} alt="System" style={{ width: '55%' }} />
                <div className="products-text">
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      marginBottom: '20px',
                      textTransform: 'uppercase',
                    }}
                  >
                    Trade, transfer <br /> and manage
                  </div>
                  {/* <div style={{ marginBottom: '20px' }}>and manage</div> */}
                  <Row style={{ marginLeft: '20px' }}>
                    <Col xs={{ span: 5, offset: 1 }} lg={{ span: 3, offset: 5 }}>
                      <img src={CNYImg} alt="Banner" />
                      <div className="currency-text">
                        Restricted <br /> currencies
                      </div>
                    </Col>
                    <Col xs={{ span: 10, offset: 1 }} lg={{ span: 3, offset: 2 }}>
                      <img src={EURImg} alt="Banner" />
                      <div className="currency-text">
                        Fiat <br /> currencies
                      </div>
                    </Col>
                    <Col xs={{ span: 5 }} lg={{ span: 3, offset: 2 }}>
                      <img src={BTCImg} alt="Banner" />
                      <div className="currency-text">
                        Crypto <br /> currencies
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={{ span: 7, offset: 1 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <div className="mainContent-right">
                <DynamicCard
                  onFieldsChange={onFieldsChange}
                  onSubmitForm={onSubmitForm}
                  signUp={signUp}
                  progressLog={progressLog}
                  formTitle={formTitle}
                  formSubTitle={formSubTitle}
                  formData={formData}
                  label={label}
                  viewForm={viewForm}
                  cardMessage={cardMessage}
                  loading={loading}
                  mainLoader={mainLoader}
                  handleClickFun={handleClickFun}
                  inProgressItem={inProgressItem}
                  enableLoginLink={enableLoginLink}
                  footerHeight={footerHeight}
                  isUserEnabled2FA={isUserEnabled2FA}
                  onChangeEnable2fa={onChangeEnable2fa}
                  isTermsConditionsAccpted={isTermsConditionsAccpted}
                  isUserNeedEmailUpdates={isUserNeedEmailUpdates}
                  onChangeTermsConditions={onChangeTermsConditions}
                  onChangeEmailUpdates={onChangeEmailUpdates}
                  stepStatus={stepStatus}
                  companyStageOneStatus={companyStageOneStatus}
                  companyStageTwoStatus={companyStageTwoStatus}
                  finalProgressStatus={finalProgressStatus}
                  registrationStatus={registrationStatus}
                  productSelectionStatus={productSelectionStatus}
                  preQualificationStatus={preQualificationStatus}
                  initialFormValues={initialFormValues}
                />
              </div>
            </Col>
          </Row>
          {/* <Footer
            copyRights={copyRights}
            handlePrivacyPolicy={handlePrivacyPolicy}
            handleTermsAndServices={handleTermsAndServices}
          /> */}
        </div>
      )}
    </div>
  )
}

export default SignUp
